import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';

import './CopyLinkButton.scss';
import LinkIcon from '../../../Icons/LinkIcon/LinkIcon';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import { SHARE_DESTINATIONS } from '../CommunityShareButton/CommunitySharePopup/consts';

const CopyLinkButton = ({ hash, urlToShare, onSuccess }) => {
    const [isActive, setIsActive] = React.useState(false);
    const [isCopied, setIsCopied] = React.useState(false);
    const { isLoggedIn, wrapAuth } = useContext(PageContext);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const labelCopy = isCopied ? 'Link copied!' : 'Copy Link';
    const labelStyling = isCopied ? 'copied-styling' : '';
    const copyValue = urlToShare || content.contentUrl;

    const handleClick = useCallback(async () => {
        if (!isLoggedIn()) return;
        if (!navigator?.clipboard) return;
        setIsActive(!isActive);
        try {
            await navigator.clipboard.writeText(copyValue);
            setIsCopied(true);
            setTimeout(() => onSuccess(SHARE_DESTINATIONS.CLICKED_LINK), 1000);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [isLoggedIn, isActive, setIsActive, copyValue, onSuccess]);

    const authMetrics = {
        login_trigger: 'community-share',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
    };

    return wrapAuth(
        `community-share-${content.hash}`,
        <button
            type="button"
            className="component-Community-ReactionBar-CopyLinkButton"
            onClick={handleClick}
        >
            <LinkIcon />
            <p className={`label ${labelStyling}`}>{labelCopy}</p>
        </button>,
        authMetrics
    );
};

CopyLinkButton.propTypes = {
    hash: PropTypes.string.isRequired,
    urlToShare: PropTypes.string,
    onSuccess: PropTypes.func,
};

CopyLinkButton.defaultProps = {
    urlToShare: null,
    onSuccess: () => {},
};

CopyLinkButton.displayName = 'CopyLinkButton';

export default React.memo(CopyLinkButton);
